/**
 * Classroom management API – all endpoints used by classroom management.
 * Base path: /admin/classroom (classroom routes mounted in backend organization routes).
 */
import {
  DELETE,
  GET,
  POST,
  PUT,
  UPLOAD_FILE,
} from "../../apiController";

const CLASSROOM = '/admin/classroom';

// ==================== CLASSROOM MANAGEMENT ====================

// Get classroom details with pagination and search
export const getClassroomDetails = (data) => {
  return POST(`${CLASSROOM}/get_classes`, data);
};

// Get complete classroom inventory report payload for modal + Excel export
export const getClassroomManagementReport = () => {
  return GET(`${CLASSROOM}/report`);
};

// Create new classroom
export const createClassroom = (data) => {
  return UPLOAD_FILE(`${CLASSROOM}`, data);
};

// Update classroom details
export const updateClassroomDetails = (data) => {
  return PUT(`${CLASSROOM}`, data);
};

// Update classroom status
export const updateClassroomStatus = (data) => {
  return PUT(`${CLASSROOM}/status`, data);
};

// Delete classroom
export const deleteClassroom = (data) => {
  return DELETE(`${CLASSROOM}/${data.classroom_id}`);
};

// Get all trainers
export const getAllTrainers = () => {
  return GET(`${CLASSROOM}/get_trainers`);
};

// Get classroom dashboard data
export const classroomDashboard = (data) => {
  return POST(`${CLASSROOM}/dashboard`, data);
};

// Update classroom tab visibility
export const classroomVisibility = (data) => {
  return POST(`${CLASSROOM}/visibility`, data);
};

export const getClassroomCourses = (classroomId) => GET(`${CLASSROOM}/${classroomId}/courses`);
export const getEligibleClassroomCourses = (classroomId, search = '') =>
  GET(`${CLASSROOM}/${classroomId}/courses/eligible?search=${encodeURIComponent(search)}`);
export const attachCoursesToClassroom = (classroomId, course_ids) =>
  POST(`${CLASSROOM}/${classroomId}/courses`, { course_ids });
export const removeCourseFromClassroom = (classroomId, courseId) =>
  DELETE(`${CLASSROOM}/${classroomId}/courses/${courseId}`);
